import script from "./GeneralData.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralData.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__